<template>
  <div class="is-border is-margin-top-xsmall">
    <div
      class="columns is-gapless has-background-white is-marginless-bottom"
      :class="{'is-minH50p is-flex' : index < 1}">
      <div class="column is-self-centered is-padding-right is-padding-left">
        <div class="is-self-centered">
          <span class="is-uppercase title is-6">Prêt N° {{ index + 1 }}</span>
        </div>
      </div>
      <div
        v-if="index >= 1"
        class="column is-narrow has-background-white is-border-left is-flex">
        <a
          data-tooltip="Supprimer la ligne"
          class="page-header-btn is-small is-square tooltip is-tooltip-top"
          @click="remove()">
          <span class="icon is-size-4">
            <i class="fal fa-trash-alt" />
          </span>
        </a>
      </div>
    </div>
    <div class="is-border-top has-background-light is-padding-left-small">
      <div class="is-self-centered">
        <div class="is-padding-top-small is-padding-bottom-small">
          <div>
            <input
              :id="`hasCourtier-${index}`"
              v-model="hasCourtier"
              name="hasCourtier"
              class="switch is-success is-rounded"
              type="checkbox"
              @input="hasCourtier = !hasCourtier">
            <label
              :for="`hasCourtier-${index}`"
              style="font-size: 12.5px"
              class="is-uppercase">Déclarer courtier</label>
          </div>
        </div>
      </div>
      <div
        v-if="hasCourtier"
        class="columns is-multiline is-padding-bottom-small">
        <div class="column is-6 is-padding-right">
          <r-label
            :label="loan.courtier.tiers_id ? 'Courtier du référentiel' : 'Rechercher un courtier au référentiel'"
            :is-required="false"
            :value="selectedCourtier" />
          <tiers-selector
            :selected="selectedCourtier"
            :types="['courtier']"
            placeholder="Nom, ville..."
            @select="selectCourtier"
            @unlink="unlinkCourtier" />
        </div>
        <div class="column is-6"></div>
        <div class="column is-4">
          <r-label
            :label="'Nom du courtier'"
            :is-required="false"
            :value="loan.courtier.name" />
          <v-input
            id="courtier_name"
            :disabled="!!loan.courtier.tiers_id"
            v-validate="'min:2'"
            name="courtier_name"
            :model="loan.courtier.name"
            data-vv-as="Nom du courtier"
            :errors-bag="errors"
            data-vv-value-path="val"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].courtier.name`, value })" />
        </div>
        <div class="column is-4">
          <r-label
            :label="'Téléphone'"
            :is-required="false"
            :value="loan.courtier.phone" />
          <v-input
            id="courtier_phone"
            :disabled="!!loan.courtier.tiers_id"
            v-validate="'min:9'"
            name="courtier_phone"
            :model="loan.courtier.phone"
            data-vv-as="Téléphone"
            input-type="tel"
            :errors-bag="errors"
            data-vv-value-path="val"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].courtier.phone`, value })" />
        </div>
        <div class="column is-4">
          <r-label
            :label="'Email'"
            :is-required="false"
            :value="loan.courtier.email" />
          <v-input
            id="courtier_email"
            :disabled="!!loan.courtier.tiers_id"
            v-validate="'required|email'"
            name="courtier_email"
            :model="loan.courtier.email"
            data-vv-as="Email"
            :errors-bag="errors"
            data-vv-value-path="val"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].courtier.email`, value })" />
        </div>
      </div>
    </div>
    <div
      class="columns is-gapless is-padding-left-small is-minH50p is-marginless-bottom"
      :class="!loan.has_mandat_courtage ? 'is-border-top has-background-light ' : 'has-background-dark'">
      <div class="column is-self-centered is-padding-right">
        <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
          <div>
            <input
              :id="index + '-has_mandat_courtage'"
              v-model="loan.has_mandat_courtage"
              :name="index + '-has_mandat_courtage'"
              class="switch is-success is-rounded"
              type="checkbox"
              @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].has_mandat_courtage`, value: loan.has_mandat_courtage })">
            <label
              :for="index + '-has_mandat_courtage'"
              style="font-size: 12.5px"
              :class="!loan.has_mandat_courtage ? '' : 'has-text-white'"
              class="is-uppercase">MANDAT DE COURTAGE</label>
          </div>
        </div>
      </div>
      <template v-if="loan.has_mandat_courtage">
        <div
          v-if="!loan.document || !loan.document.path"
          class="column is-narrow has-background-white is-border-left is-border-top is-flex">
          <div class="is-minH100">
            <label
              class="is-block w100 tooltip is-tooltip-top has-cursor-pointer"
              data-tooltip="Lier document">
              <input
                class="file-input"
                type="file"
                accept="image/*, .pdf"
                name="resume"
                @change="uploadDocument($event.target.files)">
              <span class="page-header-btn is-square is-fullwidth">
                <span
                  v-if="!loadingDoc"
                  class="icon"><i class="far fa-link" /></span>
                <span
                  v-else
                  class="icon is-size-4"><i
                    class="fas fa-spinner fa-spin" /></span>
              </span>
            </label>
          </div>
        </div>
        <template v-else>
          <div
            v-if="loan.document.display || (isAdmin && isPromoteur)"
            class="column is-narrow has-background-white is-border is-flex is-padding-small">
            <a
              class="icon has-text-grey is-self-centered tooltip is-tooltip-top"
              data-tooltip="Télécharger"
              @click="download()"><i class="fal fa-download" /></a>
          </div>
          <div
            v-if="(isAdmin && isPromoteur)"
            class="column is-narrow has-background-white is-border is-flex is-padding-small">
            <a
              class="icon has-text-grey is-self-centered tooltip is-tooltip-top"
              data-tooltip="Supprimer document lié"
              @click="unlink()"><i class="fal fa-unlink" /></a>
          </div>
        </template>
      </template>
    </div>
    <div class="is-border-top has-background-white-bis is-padding">
      <div class="columns is-multiline">
        <div class="column is-6">
          <r-label
            :label="loan.banking_agency.tiers_id ? 'Banque du référentiel' : 'Rechercher une banque au référentiel'"
            :is-required="false"
            :value="selectedBanque" />
          <tiers-selector
            :selected="selectedBanque"
            :types="['banque']"
            placeholder="Conseiller, agence, ville..."
            @select="selectBanque"
            @unlink="unlinkBanque" />
        </div>
        <div class="column is-6"></div>
        <div class="column is-12">
          <r-label
            :label="'Organisme bancaire'"
            :red-check="true"
            :value="loan.bank_name" />
          <v-input
            id="initial_bank_name"
            :disabled="!!loan.banking_agency.tiers_id"
            v-validate="'min:2'"
            name="initial_bank_name"
            :model="loan.bank_name"
            data-vv-as="Organisme bancaire"
            :errors-bag="errors"
            data-vv-value-path="val"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].bank_name`, value })" />
        </div>
        <div class="column is-4">
          <r-label
            :label="'Nom du conseiller bancaire'"
            :is-required="false"
            :value="loan.banking_agency.name" />
          <v-input
            id="banking_agency_name"
            :disabled="!!loan.banking_agency.tiers_id"
            v-validate="'min:2'"
            name="banking_agency_name"
            :model="loan.banking_agency.name"
            data-vv-as="Nom du conseiller bancaire"
            :errors-bag="errors"
            data-vv-value-path="val"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].banking_agency.name`, value })" />
        </div>
        <div class="column is-4">
          <r-label
            :label="'Téléphone'"
            :is-required="false"
            :value="loan.banking_agency.phone" />
          <v-input
            id="banking_agency_phone"
            :disabled="!!loan.banking_agency.tiers_id"
            v-validate="'min:9'"
            name="banking_agency_phone"
            input-type="tel"
            :model="loan.banking_agency.phone"
            data-vv-as="Téléphone"
            :errors-bag="errors"
            data-vv-value-path="val"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].banking_agency.phone`, value })" />
        </div>
        <div class="column is-4">
          <r-label
            :label="'Email'"
            :is-required="false"
            :value="loan.banking_agency.email" />
          <v-input
            id="banking_agency_email"
            :disabled="!!loan.banking_agency.tiers_id"
            v-validate="'required|email'"
            name="banking_agency_email"
            :model="loan.banking_agency.email"
            data-vv-as="Email"
            :errors-bag="errors"
            data-vv-value-path="val"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].banking_agency.email`, value })" />
        </div>
      </div>
    </div>
    <div class="is-border-top has-background-white is-padding">
      <!-- type de pret -->
      <div class="columns is-multiline">
        <div class="column is-4">
          <div class="is-margin-bottom-xsmall">
            <r-label
              :label="'type de prêt'"
              :is-required="false"
              :value="loan.loan_type" />
          </div>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                v-model="loan.loan_type"
                class=""
                @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].loan_type`, value: loan.loan_type })">
                <option :value="null">
                  Sélectionner
                </option>
                <option value="in_fine">
                  In Fine
                </option>
                <option value="amortissement">
                  Amortissement
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-4">
          <r-label
            :label="'Montant du prêt'"
            :value="loan.loan_value"
            :is-required="false" />
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-euro-sign" /></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="loan_value"
                v-validate="'decimal:2'"
                name="loan_value"
                :model="loan.loan_value"
                class=""
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                :three-space="true"
                input-type="number"
                data-vv-as="Montant du prêt"
                @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].loan_value`, value })" />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <r-label
            :label="'Montant de l’apport'"
            :value="loan.loan_apport"
            :is-required="false" />
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-euro-sign" /></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="loan_apport"
                v-validate="'decimal:2'"
                name="loan_apport"
                :model="loan.loan_apport"
                :three-space="true"
                class=""
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                input-type="number"
                data-vv-as="Montant de l’apport"
                @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].loan_apport`, value })" />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <r-label
            :label="'ORIGINE DE L\'APPORT'"
            :is-required="false"
            :value="loan.origin_contribution"></r-label>
          <v-input
            id="origin_contribution"
            name="origin_contribution"
            @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].origin_contribution`, value })"
            :model="loan.origin_contribution"
            data-vv-as="Origine de l'apport"
            v-validate="'min:2'"
            :errors-bag="errors"
            data-vv-value-path="val">
          </v-input>
        </div>
        <div class="column is-4">
          <r-label
            :label="'Durée du prêt'"
            :value="loan.loan_duration"
            :is-required="false"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="far fa-clock"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="loan_duration"
                name="loan_duration"
                @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].loan_duration`, value: $event})"
                :model="loan.loan_duration"
                :placeholder="'en année'"
                data-vv-as="Durée du prêt"
                :number="true"
                input-type="number"
                v-validate="'min:1'"
                :errors-bag="errors"
                data-vv-value-path="val">
              </v-input>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <r-label
            :label="'Taux d’interêt du prêt'"
            :value="loan.loan_rate"
            :is-required="false" />
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-percentage" /></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="loan_rate"
                v-validate="'decimal:2'"
                name="loan_rate"
                :model="loan.loan_rate"
                class=""
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                input-type="number"
                data-vv-as="Taux d’interêt du prêt"
                @input="value => $store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].loan_rate`, value })" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <!-- Date butoir de demande de prêt -->
        <div class="column is-4">
          <date-picker
            :model="loan.loan_application_deadline"
            :red-check="true"
            :style-version="2"
            @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].loan_application_deadline`, value: $event})"
            label="Date butoir de demande de prêt"></date-picker>
        </div>
        <div class="column is-4 ">
          <date-picker
            :model="loan.depot_de_dossier"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :is-required="false"
            label="DATE DE DÉPÔT DU DOSSIER"
            @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].depot_de_dossier`, value: $event })" />
        </div>
      </div>
      <div class="columns is-multiline">
        <!-- date butoir accord de pret -->
        <div class="column is-4">
          <date-picker
            :model="loan.depose_date_loan_offer"
            :red-check="true"
            :style-version="2"
            @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].depose_date_loan_offer`, value: $event})"
            label="Date butoir accord de prêt"></date-picker>
        </div>
        <div class="column is-6 is-4-widescreen">
          <date-picker
            :model="loan.accord_banque"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :is-required="false"
            label="DATE ACCORD BANQUE"
            @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].accord_banque`, value: $event })" />
        </div>
        <div class="column is-6 is-4-widescreen">
          <date-picker
            :model="loan.edition_de_l_offre"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :red-check="true"
            :is-required="true"
            label="EDITION DE L’OFFRE"
            @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].edition_de_l_offre`, value: $event })" />
        </div>
      </div>
      <div class="columns is-multiline">
        <!-- date validité offre de pret -->
        <div class="column is-4">
          <date-picker
            :model="loan.validity_date_loan_offer"
            :red-check="true"
            :style-version="2"
            @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].validity_date_loan_offer`, value: $event })"
            label="Date validité offre de prêt"></date-picker>
        </div>
        <div class="column is-6 is-4-widescreen">
          <date-picker
            :model="loan.signature_de_l_offre"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :red-check="true"
            :is-required="true"
            label="SIGNATURE DE L’OFFRE"
            @input="$store.commit('modifyCurrentSale', { key: `funding_data.loans[${index}].signature_de_l_offre`, value: $event })" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Upload, DefaultValues, Adv } from '@/mixins'
import { TIERS_RESOURCE } from '@/components/tiers/tiersConstants'
export default {
  name: 'LoanItem',
  components: {
    TiersSelector: () => import('@/components/tiers/TiersSelector')
  },
  mixins: [Upload, DefaultValues, Adv],
  props: {
    source: {
      type: Object
    },
    multipleLoan: Boolean,
    index: Number
  },
  data () {
    return {
      validDocument: null,
      files: [],
      loadingDoc: false,
      hasCourtier: false,
      selectedCourtier: null,
      selectedBanque: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'currentUserPk', 'isPromoteur']),
    /**
      * loan from source
      * @returns {object}
      */
    loan () {
      return this.source
    },
    /**
      * loan is empty
      * @returns {boolean}
      */
    isEmpty () {
      return (this.loan.bank_name === null || this.loan.bank_name === '') &&
          (this.loan.depot_de_dossier === null || this.loan.depot_de_dossier === '') &&
          (this.loan.accord_banque === null || this.loan.accord_banque === '') &&
          (this.loan.edition_de_l_offre === null || this.loan.edition_de_l_offre === '') &&
          (this.loan.signature_de_l_offre === null || this.loan.signature_de_l_offre === '') &&
          (this.loan.loan_value === null || this.loan.loan_value === '') &&
          (this.loan.loan_apport === null || this.loan.loan_apport === '') &&
          (this.loan.loan_type === null || this.loan.loan_type === '') &&
          (this.loan.validity_date_loan_offer === null || this.loan.validity_date_loan_offer === '') &&
          (this.loan.deposit_paid_to === null || this.loan.deposit_paid_to === '') &&
          (this.loan.loan_payment_date === null || this.loan.loan_payment_date === '') &&
          (this.loan.loan_application_deadline === null || this.loan.loan_application_deadline === '') &&
          (!this.loan.document || this.loan.document.cloudinary_id === null || this.loan.document.path === null)
    },
    filteredDepositPaidList () {
      return this.DepositPaidList.filter(x => !x.hide)
    }
  },
  watch: {
    hasCourtier (val) {
      if (!val) {
        this.selectedCourtier = null
        this.loan.courtier = {
          name: null,
          phone: null,
          email: null
        }
        this.$store.commit('modifyCurrentSale', { key: `funding_data.loans[${this.index}].courtier`, courtier: this.loan.courtier })
      }
    }
  },
  async created () {
    this.files = new FormData()
    if (!this.loan.banking_agency) {
      this.loan.banking_agency = {
        name: null,
        phone: null,
        email: null
      }
    }
    if (!this.loan.courtier) {
      this.loan.courtier = {
        name: null,
        phone: null,
        email: null
      }
    }
    if (this.loan.courtier.name || this.loan.courtier.phone || this.loan.courtier.email) this.hasCourtier = true
    this.initTiersSelection('courtier')
    this.initTiersSelection('banking_agency')
    if (Array.isArray(this.loan.deposit_paid_to) === false) {
      if (this.loan.deposit_paid_to !== null) {
        this.loan.deposit_paid_to = null
        const fixLoan = this.loan.deposit_paid_to
        this.$store.commit('modifyCurrentSale', { key: `funding_data.loans[0].deposit_paid_to`, value: fixLoan })
      }
    }
  },
  methods: {
    /**
      * Précharge la sélection affichée si le prêt est déjà lié au référentiel
      * @param {string} field - 'courtier' ou 'banking_agency'
      */
    async initTiersSelection (field) {
      const target = this.loan[field]
      if (!target || !target.tiers_id) return
      try {
        let { data } = await this.$api.getOne(TIERS_RESOURCE, target.tiers_id)
        const { interlocuteurs, ...tiers } = data
        const interlocuteur = (interlocuteurs || []).find(i => i.pk === target.interlocuteur_id)
        if (interlocuteur) {
          const selection = { ...interlocuteur, tiers }
          if (field === 'courtier') this.selectedCourtier = selection
          else this.selectedBanque = selection
        }
      } catch (e) {
        this.$set(target, 'tiers_id', null)
        this.$set(target, 'interlocuteur_id', null)
      }
    },
    /**
      * Sélection en un clic : référence la personne et sa fiche, copie les coordonnées
      * @param {object} interlocuteur
      */
    selectCourtier (interlocuteur) {
      this.selectedCourtier = interlocuteur
      const name = `${(interlocuteur.last_name || '').toUpperCase()} ${interlocuteur.first_name || ''}`.trim()
      this.updateLoanField('courtier.tiers_id', interlocuteur.tiers.pk)
      this.updateLoanField('courtier.interlocuteur_id', interlocuteur.pk)
      this.updateLoanField('courtier.name', name)
      this.updateLoanField('courtier.phone', interlocuteur.phone || interlocuteur.tiers.phone)
      this.updateLoanField('courtier.email', interlocuteur.email || interlocuteur.tiers.email)
    },
    /**
      * Délier vide aussi les champs : évite la recréation immédiate d'un doublon
      */
    unlinkCourtier () {
      this.selectedCourtier = null
      this.updateLoanField('courtier.tiers_id', null)
      this.updateLoanField('courtier.interlocuteur_id', null)
      this.updateLoanField('courtier.name', null)
      this.updateLoanField('courtier.phone', null)
      this.updateLoanField('courtier.email', null)
    },
    unlinkBanque () {
      this.selectedBanque = null
      this.updateLoanField('banking_agency.tiers_id', null)
      this.updateLoanField('banking_agency.interlocuteur_id', null)
      this.updateLoanField('bank_name', null)
      this.updateLoanField('banking_agency.name', null)
      this.updateLoanField('banking_agency.phone', null)
      this.updateLoanField('banking_agency.email', null)
    },
    /**
      * Sélection banque : la fiche donne l'organisme, l'interlocuteur le conseiller
      * @param {object} interlocuteur
      */
    selectBanque (interlocuteur) {
      this.selectedBanque = interlocuteur
      const name = `${(interlocuteur.last_name || '').toUpperCase()} ${interlocuteur.first_name || ''}`.trim()
      this.updateLoanField('banking_agency.tiers_id', interlocuteur.tiers.pk)
      this.updateLoanField('banking_agency.interlocuteur_id', interlocuteur.pk)
      this.updateLoanField('bank_name', interlocuteur.tiers.name)
      this.updateLoanField('banking_agency.name', name)
      this.updateLoanField('banking_agency.phone', interlocuteur.phone || interlocuteur.tiers.phone)
      this.updateLoanField('banking_agency.email', interlocuteur.email || interlocuteur.tiers.email)
    },
    /**
      * Écrit un champ du prêt dans l'objet local ET le store
      * @param {string} path - chemin relatif au prêt (ex: 'courtier.name')
      * @param {*} value
      */
    updateLoanField (path, value) {
      const parts = path.split('.')
      if (parts.length === 2) {
        this.$set(this.loan[parts[0]], parts[1], value)
      } else {
        this.$set(this.loan, parts[0], value)
      }
      this.$store.commit('modifyCurrentSale', { key: `funding_data.loans[${this.index}].${path}`, value })
    },
    /**
      * delete loan
      */
    remove () {
      this.$set(this.loan, 'document', null)
      this.$emit('removeLoan', this.index)
    },
    /**
      * unlink document
      */
    unlink () {
      this.loan.document = null
      this.$store.commit('modifyCurrentSale', { key: `funding_data.loans[${this.index}].document`, value: null })
    },
    /**
      * download document
      */
    download () {
      let link = document.createElement('a')
      link.href = this.loan.document.path
      link.target = '_blank'
      link.click()
    },
    /**
       * upload Document
       * @param {array} files
       */
    async uploadDocument (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.validDocument = await this.checkAutorizedFile(file)
        this.files.append('file[]', file, file.name)
      }
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let uploadFiles = this.files
      this.loadingDoc = true
      let config = {
        onUploadProgress: progressEvent => {
          this.progressData = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
        }
      }
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: uploadFiles, config })
        let hostedFiles = res.data.slice()
        let newIndex = this.index + 1
        hostedFiles = hostedFiles.map(x => {
          return {
            fus_id: x.id,
            cloudinary_id: x.cloudinary_id,
            cloudinary_version: x.cloudinary_version,
            path: x.path,
            filename: 'mandat-de-courtage-prêt-' + newIndex,
            display: x.display || true,
            destination: ['display_in_adv']
          }
        })
        this.loadingDoc = false
        this.loan.document = hostedFiles[0]
        this.$store.commit('modifyCurrentSale', { key: `funding_data.loans[${this.index}].document`, value: hostedFiles[0] })
        this.$toasted.global.success('Le document à été téléchargé avec succès')
      } catch (e) {
        this.loadingDoc = false
        console.log(e)
      }
    },
    initSaleForm (loan) {
      if (loan.deposit_paid_to && loan.deposit_paid_to.length) {
        this.loan.deposit_paid_to = loan.deposit_paid_to.map(x => this.filteredDepositPaidList.find(y => y.value === x))
      }
    }
  }
}
</script>

<style>
.input[type='number']::-webkit-outer-spin-button,
.input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
